import { render, staticRenderFns } from "./SavedGoalContentPage.vue?vue&type=template&id=33ca397a&scoped=true"
import script from "./SavedGoalContentPage.vue?vue&type=script&lang=js"
export * from "./SavedGoalContentPage.vue?vue&type=script&lang=js"
import style0 from "./SavedGoalContentPage.vue?vue&type=style&index=0&id=33ca397a&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33ca397a",
  null
  
)

export default component.exports